module.exports = __webpack_public_path__ + "images/line_friend_lp/step3-image_a7277e7122fbf3608a70d718b3ffb427.png";